<template>
  <a
    class="cursor-pointer bg-gray-400 inline-flex overflow-hidden relative"
    :class="[radiusClass]"
    :href="url"
    download
  >
    <div class="flex h-full bg-dark-800/50 w-full top-0 left-0 absolute justify-center items-center">
      <Icon icon="ph:play" width="20" class="text-white" />
    </div>
    <img :src="proxiedUrl" class="h-full w-full" loading="lazy" alt="" />
  </a>
</template>

<script>
import { computed } from 'vue'
import { openVideoViewer } from '@/utils/events'

export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    preview: {
      type: String,
      default: ''
    },
    w: {
      type: [String, Number],
      default: 100
    },
    h: {
      type: [String, Number],
      default: null
    },
    fit: {
      type: String,
      default: 'cover',
      validator: val => ['contain', 'cover'].includes(val)
    },
    radiusClass: {
      type: String,
      default: 'rounded-xl'
    },
  },
  setup (props) {
    const proxiedUrl = computed(() => {
      const url = new URL(props.preview)
      const height = props.h ?? props.w

      url.searchParams.append('output', 'webp')
      url.searchParams.append('q', 90)
      url.searchParams.append('w', props.w)
      url.searchParams.append('h', height)
      url.searchParams.append('fit', props.fit)

      return url.toString()
    })

    return {
      proxiedUrl,
    }
  }
}
</script>
